import React from 'react';
import TimelineCalendar from '../../components/features/events/TimelineCalendar';
import Card from '../../components/ui/Card';

export default function CalendrierPage() {
  return (
    <div className="space-y-6 animate-fade-in px-4">
      <div className="text-center space-y-2 max-w-3xl mx-auto">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Calendrier Annuel
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Découvrez le programme prévisionnel de l'année 2025/2026 de l'ACEM Fès.
        </p>
      </div>

      <TimelineCalendar onlyUpcoming={false} />
    </div>
  );
}
